module.exports = __webpack_public_path__ + "img/designed-for-everyone.e5c67be6.jpg";